module.exports = __webpack_public_path__ + "static/HTV-63dc3ffc5b22f342ca90863af4d7d431.png";